export enum Hosts {
  Dev = "gocardless.localhost:3012",
  Staging = "manage.gocardless-staging.io",
  Prod = "manage.gocardless.com",
}

export const host = typeof window !== "undefined" ? window.location.host : "";
export const isProd = host === Hosts.Prod;
export const isDev = host === Hosts.Dev;
